import { render, staticRenderFns } from "./ActionTwo.vue?vue&type=template&id=b90a149e&scoped=true&"
import script from "./ActionTwo.vue?vue&type=script&lang=js&"
export * from "./ActionTwo.vue?vue&type=script&lang=js&"
import style0 from "./ActionTwo.vue?vue&type=style&index=0&id=b90a149e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a149e",
  null
  
)

export default component.exports